var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('notice-box',{staticClass:"-cancel _mt-60 _mb-md-120 _mb-sm-60"},[_c('notice-header',[_c('h1',{staticClass:"heading"},[_vm._v("お申し込みキャンセルを受け付けました")])]),_vm._v(" "),_c('notice-body',[_vm._v("今後ともau PAY スマートローンをお引き立てのほどよろしくお願い申しあげます。")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77cdc01f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/En014.vue
// module id = null
// module chunks = 